import React, { useState } from "react";
import ConstructionRequestTable from "./ConstructionRequestTable";

export default function ConstructionRequestHandle() {
	const [filter, setFilter] = useState(null);
	const [configFilter, setConfigFilter] = useState(null);
	const [query, setQuery] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);

	const handleQueryChange = (e) => {
		// Handle both event objects and direct string values
		const newQuery = typeof e === "string" ? e : e?.target?.value || "";
		setQuery(newQuery);
		setCurrentPage(1);
	};
	return (
		<div>
			<ConstructionRequestTable
				query={query}
				setQuery={setQuery}
				filter={filter}
				setFilter={setFilter}
				handleQueryChange={handleQueryChange}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				configFilter={configFilter}
				setConfigFilter={setConfigFilter}
			/>
		</div>
	);
}
